import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { Features } from '../models/features.model'

@Injectable({ providedIn: 'root' })
export class BypassMaintGuard implements CanActivate {
    constructor(
        private router: Router,
        private features: Features
    ) {}

    canActivate(): boolean {
        if (!this.features.enableMaintenance) {
            this.router.navigate(['/'])
            return false
        }

        sessionStorage.setItem('bypassMode', 'true')
        return true
    }
}
